<div class="row">
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Stato lavorazione'"
    [valueInput]="ctxBodyFascicolo.fascicolo.statoLavorazione ? ctxBodyFascicolo.fascicolo.statoLavorazione.label : ''"></div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'N° sinistro'"
    [valueInput]="ctxBodyFascicolo.fascicolo.nSinistro ? ctxBodyFascicolo.fascicolo.nSinistro : ''"></div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'" [labelInput]="'Data sinistro'"
    [valueInput]="ctxBodyFascicolo.fascicolo.dataSinistro ? ctxBodyFascicolo.fascicolo.dataSinistro : ''"></div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'" [labelInput]="'Data denuncia'"
    [valueInput]="ctxBodyFascicolo.fascicolo.dataDenuncia ? ctxBodyFascicolo.fascicolo.dataDenuncia : ''"></div>
</div>
<div class="row">
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo gestione sinistro'"
  [valueInput]="ctxBodyFascicolo.fascicolo.tipoGestioneSinistro ? ctxBodyFascicolo.fascicolo.tipoGestioneSinistro : ''"></div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Canale apertura'"
    [valueInput]="ctxBodyFascicolo.fascicolo.canaleApertura ? ctxBodyFascicolo.fascicolo.canaleApertura.label : ''"></div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'RCT/RCO'"
    [valueInput]="ctxBodyFascicolo.fascicolo.tipoResponsabilita ? ctxBodyFascicolo.fascicolo.tipoResponsabilita : ''">
  </div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Luogo'"
    [valueInput]="ctxBodyFascicolo.fascicolo.luogo ? ctxBodyFascicolo.fascicolo.luogo : ''"></div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p><label class="col-sm-12">Descrizione</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.descrizione }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Protocollo denuncia'"
    [valueInput]="ctxBodyFascicolo.fascicolo.protocolloDenuncia ? ctxBodyFascicolo.fascicolo.protocolloDenuncia : ''">
  </div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Presidio/distretto'"
    [valueInput]="ctxBodyFascicolo.fascicolo.presidioDistretto ? ctxBodyFascicolo.fascicolo.presidioDistretto.label: ''">
  </div>
  <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo danno'"
    [valueInput]="ctxBodyFascicolo.fascicolo.tipoDanno ? ctxBodyFascicolo.fascicolo.tipoDanno.label : ''"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo valutazione'"
    [valueInput]="ctxBodyFascicolo.fascicolo.tipoValutazione ? ctxBodyFascicolo.fascicolo.tipoValutazione.label : ''"></div>
</div>
<div class="row">
  <div *ngIf="ctxBodyFascicolo.fascicolo.morte!=null" labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Decesso'"
    [valueInput]="ctxBodyFascicolo.fascicolo.morte ? ctxBodyFascicolo.fascicolo.morte : ''"></div>
  <div *ngIf="ctxBodyFascicolo.fascicolo.morte==null" labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Decesso'"
    [valueInput]="'Non specificato'"></div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p><label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>